import React, { createContext, useContext, useState } from 'react'

const PendingCompPayRequestContext = createContext();

export default function PendingCompPayRequestProvider({ children }) {
    const [pendingCompPayCount, setPendingCompPayCount] = useState(0);

    const updatePendingCompPayCount = (newCount) => {
    setPendingCompPayCount(newCount);
  };

  return (
    <PendingCompPayRequestContext.Provider value={{ pendingCompPayCount, updatePendingCompPayCount }}>
      {children}
    </PendingCompPayRequestContext.Provider>
  )
}

export const usePendingCompPayRequests = () => useContext(PendingCompPayRequestContext);
